import { useParams } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useLinksDestinations, useLinksPromotion, useLinksUpdate } from "./links-queries";
import styles from "./links.module.scss";
import { Field, Form, Formik } from "formik";
import { useMemo } from "react";
import { icons } from "./links-icons";
import * as Yup from "yup";

export function LinksDestinations() {

    const { accountID, showID, promotionID } = useParams();
    const { data: promotion } = useLinksPromotion(
        accountID,
        showID,
        promotionID
    );
    const { data: destinations } = useLinksDestinations(accountID, showID, promotionID);
    const update = useLinksUpdate(accountID, showID, promotionID);

    const initialValues = useMemo(() => {
        if (promotion) return ({
            ...promotion,
            destinations: promotion.destinations.map(d=>""+d)
        })
    }, [promotion]);

    return <div className={styles.section}>
        <Formik
            initialValues={initialValues}
            onSubmit={values=>update.mutateAsync(values)}
            enableReinitialize
        >
            <Form>
                <table style={{marginBottom: "1rem"}}>
                    <tbody>
                        {destinations
                            ?.filter(d => d.active || d.promotionDestinationID)
                            .map(d => <tr key={d.destinationPlatformID}>
                                <td>
                                    <label className={styles.destination}>
                                        <Field
                                            name="destinations"
                                            type="checkbox"
                                            value={"" + d.destinationPlatformID}
                                            //disabled={!(d.canLink || d.promotionDestinationID)}
                                        />
                                        {icons[d.iconUrl]}
                                        {d.name}
                                    </label>
                                </td>
                                <td>{" "}</td>
                                <td>
                                    <small>{d.canLink ? <a href={d.destinationUrl} target="_blank" style={{ display: "block" }}><FaExternalLinkAlt /></a> : null}</small>
                                </td>
                        </tr>)}
                    </tbody>
                </table>
                <button type="submit">Save</button>
            </Form>
        </Formik>

        {/*<pre>{JSON.stringify(destinations, null, 2)}</pre>*/}
        
    </div>;
}